import { render, staticRenderFns } from "./LightSwitcher.vue?vue&type=template&id=3ea187e9&scoped=true&"
import script from "./LightSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LightSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea187e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea187e9')) {
      api.createRecord('3ea187e9', component.options)
    } else {
      api.reload('3ea187e9', component.options)
    }
    module.hot.accept("./LightSwitcher.vue?vue&type=template&id=3ea187e9&scoped=true&", function () {
      api.rerender('3ea187e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/LightSwitcher.vue"
export default component.exports